import { toast } from 'react-toastify';


interface MyToastShowProps {
    message: string;
    type: 'success' | 'error' | 'warning' | 'info';
    position?: 'top-right' | 'top-center' | 'top-left' | 'bottom-right' | 'bottom-center' | 'bottom-left';
    autoClose?: number;
}


const MyToastShow = ({ message, type, position = 'bottom-left', autoClose = 5000 }: MyToastShowProps) => {

    const theme = localStorage.getItem('darkTheme') === 'true' ? 'dark' : 'light';

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    toast[type](message, {
        position: position,
        autoClose: autoClose,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: theme,
    });

}

export default MyToastShow;